import { render } from "./HFO_BI_001_KBPRM.vue?vue&type=template&id=19ea8d04&scoped=true"
import script from "./HFO_BI_001_KBPRM.vue?vue&type=script&lang=js"
export * from "./HFO_BI_001_KBPRM.vue?vue&type=script&lang=js"

import "./HFO_BI_001_KBPRM.vue?vue&type=style&index=0&id=19ea8d04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ea8d04"]])

export default __exports__